// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pivot-table-settings-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background-color: var(--sub-window-bg);
    transition: height 0.5s ease-in-out, opacity 0.5s ease;
    width: 100%;
    max-width: 100%;
    /* need to subtract size of block-options-bar (kinda messy)*/
    height: calc(100% - 40px);
    border-bottom: var(--border);
}

.pivot-table-settings-combo {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: start;
    min-width: 300px;
    max-width: calc(50% - 10px);
    padding: var(--padding);
    overflow: auto;
    height: 100%;
    transition: height 0.5s ease-in-out, opacity 0.5s ease;
}

.pivot-table-settings-combo .ecl-select-new {
    width: 100%;
}

.pivot-table-settings-combo-label {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    align-items: center;
    min-height: 45px;
}

.pivot-table-settings-combo-measures {
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    width: 100%
}

.pivot-table-settings-combo-measure-additional {
    padding-left: 20px;
    display: flex;
    flex-direction: column;
}

.measure-label {
    text-transform: capitalize;
}

.percentile-combo {
    display: flex;
    align-items: center;
}

.percentile-combo .ecl-select-new {
    width: calc(100% - 40px);
}


@media (max-width: 769px) and (orientation: portrait),
(max-height: 769px) and (orientation: landscape) {
    .pivot-table-settings-box {
        overflow: auto;
    }

    .pivot-table-settings-combo {
        width: 100%;
        height: unset;
        min-width: unset;
        max-width: unset;
        overflow: unset;
    }
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/ECLPivotTable/components/PivotTableSettings.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,sCAAsC;IACtC,sDAAsD;IACtD,WAAW;IACX,eAAe;IACf,4DAA4D;IAC5D,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,sDAAsD;AAC1D;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;IACnB;AACJ","sourcesContent":[".pivot-table-settings-box {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n    background-color: var(--sub-window-bg);\r\n    transition: height 0.5s ease-in-out, opacity 0.5s ease;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    /* need to subtract size of block-options-bar (kinda messy)*/\r\n    height: calc(100% - 40px);\r\n    border-bottom: var(--border);\r\n}\r\n\r\n.pivot-table-settings-combo {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-grow: 1;\r\n    align-items: start;\r\n    min-width: 300px;\r\n    max-width: calc(50% - 10px);\r\n    padding: var(--padding);\r\n    overflow: auto;\r\n    height: 100%;\r\n    transition: height 0.5s ease-in-out, opacity 0.5s ease;\r\n}\r\n\r\n.pivot-table-settings-combo .ecl-select-new {\r\n    width: 100%;\r\n}\r\n\r\n.pivot-table-settings-combo-label {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    width: 100%;\r\n    align-items: center;\r\n    min-height: 45px;\r\n}\r\n\r\n.pivot-table-settings-combo-measures {\r\n    padding-left: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    max-width: 100%;\r\n    width: 100%\r\n}\r\n\r\n.pivot-table-settings-combo-measure-additional {\r\n    padding-left: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.measure-label {\r\n    text-transform: capitalize;\r\n}\r\n\r\n.percentile-combo {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.percentile-combo .ecl-select-new {\r\n    width: calc(100% - 40px);\r\n}\r\n\r\n\r\n@media (max-width: 769px) and (orientation: portrait),\r\n(max-height: 769px) and (orientation: landscape) {\r\n    .pivot-table-settings-box {\r\n        overflow: auto;\r\n    }\r\n\r\n    .pivot-table-settings-combo {\r\n        width: 100%;\r\n        height: unset;\r\n        min-width: unset;\r\n        max-width: unset;\r\n        overflow: unset;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
